import { useEffect } from "react";
import { getTransactions } from "../Application/Transactions.business";
import TransactionsBoard from "./TransactionsBoard";

export default function Transactions() {
  useEffect(() => {
    getTransactions();
  }, []);

  return <TransactionsBoard />;
}
